import React from 'react';
import { Link } from 'react-router-dom';
import InfoTag from 'components/InfoTag';
import exchangeIcon from 'static/images/icons/exchange.png';
import arrowIcon from 'static/images/icons/icon-arrow.svg';
import classlist from 'utils/classlist';
import { RecommendCurrencyEnum, RecommendDepositBankBase } from '../../type';
import './style.scss';

interface CardProps {
    title: string;
    subTitle?: string;
    to: string;
    icon?: string;
    disabled?: boolean;
    isFavorite?: boolean;
    mode?: 'simple';
    cardData?: RecommendDepositBankBase;
}

const Card: React.FC<CardProps> = ({ title, subTitle, icon, disabled, isFavorite, mode, cardData, to }) => {
    const isSimpleMode = mode === 'simple';

    const renderCardContent = () => {
        return (
            <div
                className={classlist('deposit-way-card', {
                    disabled,
                    simple: isSimpleMode
                })}>
                <div className="card-header">
                    <img className="icon" src={icon || exchangeIcon} alt="icon" />
                    <div>
                        <div className="title-box">
                            <span className="title">{title}</span>
                            {isFavorite && <span className="tips-info">{__('最受欢迎')}</span>}
                        </div>
                        {subTitle && <span className="desc">{subTitle}</span>}
                    </div>
                    <img className="arrow" src={arrowIcon} alt="arrow" />
                </div>
                {!isSimpleMode && cardData && (
                    <div className="card-body">
                        {cardData.arrive_time && (
                            <InfoTag
                                label={__('Should Arrive in')}
                                content={<span dangerouslySetInnerHTML={{ __html: cardData.arrive_time }} />}
                            />
                        )}
                        {cardData.estimated_cost && (
                            <InfoTag
                                label={__('预估费用')}
                                content={<span dangerouslySetInnerHTML={{ __html: cardData.estimated_cost }} />}
                            />
                        )}
                        {!!cardData.currency_type?.length && (
                            <InfoTag
                                label={__('支持币种')}
                                content={cardData.currency_type.map(t => RecommendCurrencyEnum[t]).join(' / ')}
                            />
                        )}
                        {!!cardData.recommend_reason && (
                            <InfoTag
                                label={__('优势')}
                                content={<span dangerouslySetInnerHTML={{ __html: cardData.recommend_reason }} />}
                            />
                        )}
                    </div>
                )}
            </div>
        );
    };

    if (disabled) {
        return renderCardContent();
    }

    return <Link to={to}>{renderCardContent()}</Link>;
};

export default Card;
